// Copyright 2015-2023 Nstream, inc.
// All rights reserved.

import {Lazy} from "@swim/util";
import {Uri} from "@swim/uri";
import type {Graphics} from "@swim/graphics";
import {VectorIcon} from "@swim/graphics";
import type {SheetController} from "@swim/sheet";
import type {BoardController} from "@swim/panel";
import {AspectTrait} from "@nstream/domain";
import {LaneBoardController} from "./LaneBoardController";
import {MapLaneBoardController} from "./MapLaneBoardController";
import {ValueLaneBoardController} from "./ValueLaneBoardController";
import {LanesEntityTrait} from "./"; // forward import

/** @public */
export class LaneAspectTrait extends AspectTrait {
  constructor() {
    super();
    this.id.setIntrinsic("portal");
    this.title.setIntrinsic("Portal");
    this.icon.setIntrinsic(LaneAspectTrait.icon);
  }

  override createTabController(): SheetController | null {
    const entityTrait = this.entity.trait;
    if (!(entityTrait instanceof LanesEntityTrait)) {
      return null;
    }

    let boardController: BoardController;
    if (entityTrait.laneType.stringValue("") === "map") {
      boardController = new MapLaneBoardController();
    } else if (entityTrait.laneType.stringValue("") === "value") {
      boardController = new ValueLaneBoardController();
    } else {
      boardController = new LaneBoardController();
    }

    const metaNodeUri = this.nodeUri.getValue();
    const nodeUri = Uri.parse(metaNodeUri.path.tail().tail().head());
    const laneUri = this.laneUri.getValue();
    boardController.nodeUri.set(nodeUri);
    boardController.laneUri.set(laneUri);

    return boardController;
  }

  @Lazy
  static get icon(): Graphics {
    return VectorIcon.create(24, 24, "M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z");
  }
}
